import SmartLink from './SmartLink';
import { Horizon, Peeks, splitArt } from './Art';

function Show({ ev, button }) {
  const when = [ev.weekday, ev.time].filter(Boolean).join(', ');
  return (
    <li className="show">
      <div className="show-date" role="img" aria-label={`${ev.weekday}, ${ev.month} ${ev.day}, ${ev.year}`}>
        <span className="show-month">{ev.month}</span>
        <span className="show-day">{ev.day}</span>
      </div>
      <div className="show-body">
        <h3 className="show-title">{ev.title}</h3>
        <p className="show-when">{when}{ev.where ? ` at ${ev.where}` : ''}</p>
        {ev.details.map((d, i) => (d.url
          ? <p key={i} className="show-detail"><SmartLink className="inline-link" url={d.url}>{d.label}</SmartLink></p>
          : <p key={i} className="show-detail">{d.text}</p>))}
        {ev.url && <SmartLink className="btn btn--line" url={ev.url}>{button}</SmartLink>}
      </div>
    </li>
  );
}

export default function Live({ live, events, status, art }) {
  const { peeks, horizon } = splitArt(art);
  return (
    <section id="live" className={`sec sec--paper live ${horizon ? 'sec--horizon' : ''}`} aria-labelledby="live-title">
      <Peeks items={peeks} />
      <div className="wrap">
        <div className="split split--live">
          <h2 id="live-title" className="display">{live.heading}</h2>
          <div>
            {status === 'loading' && <p className="muted" aria-live="polite">Loading the calendar…</p>}
            {status === 'error' && <p className="muted">The calendar can’t be reached right now. Please check back soon.</p>}
            {status === 'ready' && events.length === 0 && (
              <div className="empty">
                <p className="lede">{live.emptyTitle}</p>
                {live.emptyText && <p>{live.emptyText}</p>}
                <a className="btn btn--solid" href="#contact">{live.emptyButton}</a>
              </div>
            )}
            {events.length > 0 && <ol className="shows">{events.map((ev) => <Show key={ev.id} ev={ev} button={live.detailsButton} />)}</ol>}
          </div>
        </div>
      </div>
      {horizon && <Horizon name={horizon.name} />}
    </section>
  );
}
